import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e372a63&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2e372a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e372a63",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationsPreview: require('/home/bitrix/frontend/components/compilations/CompilationsPreview.vue').default,CompilationSection: require('/home/bitrix/frontend/components/compilations/CompilationSection.vue').default,NotFound: require('/home/bitrix/frontend/components/gallery/NotFound.vue').default,Pagination: require('/home/bitrix/frontend/components/other/Pagination.vue').default})
